import React from 'react';
import { History } from 'lucide-react';

interface ChangeHistoryButtonProps {
  onClick: () => void;
  isOpen?: boolean;
}

const ChangeHistoryButton: React.FC<ChangeHistoryButtonProps> = ({ onClick, isOpen = false }) => {
  // Don't show button when drawer is open
  if (isOpen) return null;

  return (
    <button
      onClick={onClick}
      style={{
        position: 'fixed',
        bottom: '65px',
        right: '5px',
        width: '56px',
        height: '56px',
        borderRadius: '50%',
        backgroundColor: '#48182F',
        color: 'white',
        border: 'none',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 4px 12px rgba(72, 24, 47, 0.3)',
        zIndex: 2002,
        transition: 'all 0.2s ease',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'translateY(-2px)';
        e.currentTarget.style.boxShadow = '0 6px 16px rgba(72, 24, 47, 0.4)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = '0 4px 12px rgba(72, 24, 47, 0.3)';
      }}
      title="Change History"
      aria-label="View change history"
    >
      <History size={24} />
    </button>
  );
};

export default ChangeHistoryButton;
